export default __webpack_public_path__ + "static/media/summerchallenge03.1296fbf9.jpg";